import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import ServicesOverview from './components/ServicesOverview';
import MidPageCTA from './components/MidPageCTA';
import AIAnswerBlock from './components/AIAnswerBlock';
import ProcessSection from './components/ProcessSection';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';

export default function HomePage() {
  return (
    <main>
      <Hero />
      <TrustBar />
      <ServicesOverview />
      <MidPageCTA />
      <AIAnswerBlock />
      <ProcessSection />
      <WhyChooseUs />
      <ServiceAreas />
      <Testimonials />
      <FAQ />
      <FinalCTA />
    </main>
  );
}
